import "./IconRefresh.scss"
import { classNames } from "../../helpers/cssClassHelper"
import IconContainer, { IconContainerProps } from "./IconContainer"

interface IconRefreshProps extends IconContainerProps {
    spin?: boolean
}

export default function IconRefresh(props: IconRefreshProps) {
    const className = classNames("icon-refresh", props.spin ? "spin" : "")

    return <div className={className}>
        <IconContainer {...props} >
            refresh
        </IconContainer>
    </div>
}
